import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import { Modal } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import PreviewSlider from './PreviewSlider';
import messages from '../../../../locale/jsonMessages';
import s from './PreviewModal.css';


class PreviewModal extends React.Component {
    render() {
        const { show, closePreviewModal, themes, isExplore, title } = this.props;
        const { formatMessage } = this.props.intl;
        return (<Modal show={show} onHide={closePreviewModal} dialogClassName={cx(s.layoutSettingModalPopContainer, 'commonModalContainer')}>
            <Modal.Header closeButton className='commonModalHeader'>
                <Modal.Title className='commonModalTitle'>{title} {formatMessage(messages.previewListing)}</Modal.Title>
            </Modal.Header>
            <Modal.Body bsClass='commonModalBody'>
                <PreviewSlider
                    data={themes}
                    isExplore={isExplore}
                />
            </Modal.Body>
        </Modal >)
    }
}
const mapState = state => ({});
const mapProps = {};
export default injectIntl(withStyles(s)(connect(mapState, mapProps)(PreviewModal)));